<div id="map" class="h-full w-full" [class]="styleClass()"></div>
